import {
  isValidPhoneNumber,
  parsePhoneNumber,
} from 'react-phone-number-input';
import { TPhoneInput } from 'types';

const validatePhone = ({ number, countryCode }: TPhoneInput) => {
  if (!number) {
    return true;
  }

  return (
    isValidPhoneNumber(number, countryCode) &&
    parsePhoneNumber(number, countryCode)?.number === number
  );
};

export default validatePhone;
